import { APP_CHANGE_ACTION_TYPE } from '../../constants/ReduxAsyncActions.constants';
import { AdPartnerService } from '../../services/AdPartner.service';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import {
  INIT_STATE,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS,
} from './SKAdNetwork.constants';
import type { SKAdNetworkState } from './SKAdNetwork.types';
import type { SKAdNetworkAction } from './actions';
import { FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS, GET_SKAN_AD_PARTNERS } from './actions';

function handler(state: WrappedReducer<SKAdNetworkState>, action: SKAdNetworkAction): WrappedReducer<SKAdNetworkState> {
  switch (action.type) {
    case UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING:
      return { ...state, updatingAdPartnersForSKANAgencyPermissions: true };

    case UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS:
    case UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR:
      return { ...state, updatingAdPartnersForSKANAgencyPermissions: false };

    case FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS.response:
      return {
        ...state,
        availableCampaignsForSANAdPartners: action.data,
        isLoadingAvailableCampaignsForSANAdPartners: false,
      };

    case GET_SKAN_AD_PARTNERS.response:
      return { ...state, adPartnersForSKAN: AdPartnerService.sortByCompanyName(action.data.partners), loading: false };

    default:
      return state;
  }
}

export default ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS, GET_SKAN_AD_PARTNERS],
  error: [FETCH_AVAILABLE_CAMPAIGNS_FOR_SAN_AD_PARTNERS, GET_SKAN_AD_PARTNERS],
  resetOn: [APP_CHANGE_ACTION_TYPE],
});
